var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{staticClass:"loading-modal",attrs:{"width":"460","footer-hide":"","closable":false,"mask-closable":false},model:{value:(_vm.waitModal),callback:function ($$v) {_vm.waitModal=$$v},expression:"waitModal"}},[_c('div',{staticClass:"demo-spin-container"},[_c('div',[_vm._v("加载中...")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a211846","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/index.vue
// module id = null
// module chunks = 